// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-table{display:flex;background-color:var(--color-white);align-items:center;height:100%}.empty-table__message{flex:1 1 auto;text-align:center}.empty-table__message h3{font-weight:400;color:var(--color-baby-boy-blue)}", ""]);
// Exports
module.exports = exports;
